import { Accordion } from '@base-ui-components/react'
import { LineIcon } from '@beeirl/ui/line-icon'
import { cn } from '@beeirl/ui/utils/cn'

export function Faq({
  children,
  className,
  ...props
}: React.ComponentProps<typeof Accordion.Root>) {
  return (
    <Accordion.Root
      className={cn('shadow-xs rounded-2xl border border-gray-200 p-1', className)}
      {...props}
    >
      <div className="border-px flex flex-col divide-y divide-gray-100 overflow-hidden rounded-xl border-gray-100 bg-gray-50 text-left">
        {children}
      </div>
    </Accordion.Root>
  )
}

export function FaqItem({ className, ...props }: React.ComponentProps<typeof Accordion.Item>) {
  return <Accordion.Item className={cn('group', className)} {...props} />
}

export function FaqTrigger({
  children,
  className,
  ...props
}: React.ComponentProps<typeof Accordion.Trigger> & {
  children: string
}) {
  return (
    <Accordion.Header>
      <Accordion.Trigger
        className={cn(
          'focus-visible:inset-ring-accent-600 focus-visible:inset-ring-2 flex w-full items-center justify-between px-6 py-3 text-left font-medium text-gray-900 transition-transform hover:bg-gray-100 focus-visible:outline-none group-first:focus-visible:rounded-t-xl group-last:focus-visible:rounded-b-xl [&[data-panel-open]>svg]:rotate-180 [&[data-panel-open]]:bg-gray-100',
          className
        )}
        {...props}
      >
        {children}
        <LineIcon.ChevronDown className="size-4 shrink-0 text-gray-600 transition-transform duration-200" />
      </Accordion.Trigger>
    </Accordion.Header>
  )
}

export function FaqPanel({ children, ...props }: React.ComponentProps<typeof Accordion.Panel>) {
  return (
    <Accordion.Panel hiddenUntilFound {...props}>
      <div className="text-pretty px-6 py-3 leading-7 text-gray-800">{children}</div>
    </Accordion.Panel>
  )
}
